import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ToastID = '###qDesignWebToast###';

var QToastClass = /*#__PURE__*/function () {
  // el: 外层容器；elImage： 图片容器；elText：文字容器
  function QToastClass() {
    var _defaultTextStyle;

    _classCallCheck(this, QToastClass);

    _defineProperty(this, "el", void 0);

    _defineProperty(this, "elImage", void 0);

    _defineProperty(this, "elText", void 0);

    _defineProperty(this, "timer", null);

    _defineProperty(this, "taskQueue", void 0);

    _defineProperty(this, "isShowing", void 0);

    this.el = document.createElement('div');
    this.elImage = document.createElement('img');
    this.elText = document.createElement('div');
    this.el.id = ToastID;
    /**
     * 外层容器初始样式
     */

    var defaultStyle = {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      padding: '10px 10px',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      textAlign: 'center',
      zIndex: '-9999',
      borderRadius: '5px',
      display: 'none'
    };
    /**
     * 文本容器初始样式
     * 最多展示两行，超出省略
     */

    var defaultTextStyle = (_defaultTextStyle = {
      color: '#fff',
      fontSize: '14px',
      textOverflow: '-o-ellipsis-lastline',
      overflow: 'hidden'
    }, _defineProperty(_defaultTextStyle, "textOverflow", 'ellipsis'), _defineProperty(_defaultTextStyle, "display", '-webkit-box'), _defineProperty(_defaultTextStyle, "webkitLineClamp", 2), _defineProperty(_defaultTextStyle, "webkitBoxOrient", 'vertical'), _defaultTextStyle);
    /**
     * 图片默认样式
     */

    var defaultImageStyle = {
      margin: '10px auto',
      width: '40px',
      height: '40px',
      display: 'none'
    };
    this.setStyle(this.el, defaultStyle);
    this.setStyle(this.elText, defaultTextStyle);
    this.setStyle(this.elImage, defaultImageStyle);
    document.getElementsByTagName('body')[0].appendChild(this.el);
    this.el.appendChild(this.elImage);
    this.el.appendChild(this.elText);
    this.isShowing = false; // 任务队列，用来存储不立即展示的toast

    this.taskQueue = [];
  }
  /**
   * 触发展示
   * @param toastStyle toast外层容器样式
   */


  _createClass(QToastClass, [{
    key: "active",
    value: function active(toastStyle) {
      var activeStyle = {
        display: 'block',
        zIndex: '9999',
        top: 'auto',
        bottom: toastStyle.positionOffset === 0 ? '50%' : "".concat(toastStyle.positionOffset, "px")
      };
      this.setStyle(this.el, activeStyle);

      if (!toastStyle.iconImage) {
        this.setStyle(this.elImage, {
          display: 'none'
        });
      } else {
        this.setStyle(this.elImage, {
          display: 'block'
        });
      }

      this.elImage.setAttribute('src', toastStyle.iconImage || '');
    }
    /**
     * 触发toast隐藏
     */

  }, {
    key: "notActive",
    value: function notActive() {
      var notActiveStyle = {
        display: 'none',
        zIndex: '-9999'
      };
      this.setStyle(this.el, notActiveStyle);
    }
    /**
     * 工具方法，设置样式给dom
     * @param el dom节点
     * @param style 样式
     */

  }, {
    key: "setStyle",
    value: function setStyle(el, style) {
      Object.keys(style).forEach(function (item) {
        el.style[item] = style[item];
      });
    }
    /**
     * 处理任务队列
     */

  }, {
    key: "disposeTask",
    value: function disposeTask() {
      if (!this.isShowing && this.taskQueue.length > 0) {
        var showItem = this.taskQueue.shift();

        if (!!showItem) {
          this.showPri(showItem.text, showItem.options, true);
        }
      }

      if (!this.isShowing && this.taskQueue.length < 1) {
        this.isShowing = false;
      }

      return;
    }
    /**
     * 入队，只要是不立即展示的toast都先入队后交给disposeTask统一处理
     * @param showParams 入队task的参数
     */

  }, {
    key: "addTask",
    value: function addTask(showParams) {
      this.taskQueue.push(showParams);
      this.disposeTask();
    }
    /**
     * toastshow的私有方法
     * @param text toast文案
     * @param options toast配置
     * @param fromQueue 是否来自任务队列
     */

  }, {
    key: "showPri",
    value: function showPri(text, options, fromQueue) {
      var _this = this;

      if (!text) {
        console.warn('text必传');
        return;
      } // 不立即展示的toast暂时入队


      if (options && options.strategy === 0 && !fromQueue) {
        this.addTask({
          text: text,
          options: options
        });
        return;
      } // 如果不是来自于队列的toast，那么需要清空队列


      if (!fromQueue && this.taskQueue.length > 0) {
        this.taskQueue = [];
      }

      this.elText.innerHTML = text; // 消失时长
      // 1. 大于5个字 adr: s ios: s
      // 2. 小于等于5个字 adr: s ios: s

      var duration = 2000;

      if (text.length >= 5) {
        duration = 3500;
      }

      var defautlOptions = {
        type: '',
        strategy: 1,
        position: 0,
        iconUrl: '',
        icon: ''
      };

      var _defautlOptions$optio = _objectSpread(_objectSpread({}, defautlOptions), options),
          type = _defautlOptions$optio.type,
          strategy = _defautlOptions$optio.strategy,
          position = _defautlOptions$optio.position,
          iconUrl = _defautlOptions$optio.iconUrl,
          icon = _defautlOptions$optio.icon; // position 不支持负值 默认为1底部显示无tabbar


      if (position < 0) {
        // eslint-disable-next-line no-console
        console.error('position不允许负值');
      } // Toast 中心距离屏幕顶端/底端的偏移量。 默认为0 ,组件开发者使用


      var positionOffset = 0;

      if (position === 1) {
        positionOffset = 24; //UI定义的值
      } else if (position === 2) {
        positionOffset = 74; //有tabbar时 ui定义的值
      }

      var iconImage = iconUrl ? iconUrl : '';

      switch (type) {
        case 'success':
          iconImage = 'https://s.qunarzz.com/q_design_font/images/toastSuccess.png';
          break;

        case 'error':
          iconImage = 'https://s.qunarzz.com/q_design_font/images/toastError.png';
          break;

        case 'warning':
          iconImage = 'https://s.qunarzz.com/q_design_font/images/toastWarning.png';
          break;

        default:
          iconImage = iconUrl ? iconUrl : '';
          break;
      }

      this.active({
        positionOffset: positionOffset,
        iconImage: iconImage
      });

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.isShowing = true;
      this.timer = setTimeout(function () {
        _this.elText.innerHTML = '';

        _this.notActive();

        _this.isShowing = false;

        _this.disposeTask();
      }, duration);
    }
    /**
     * 对外展示toast的接口
     * @param text toast文案
     * @param options toast配置
     */

  }, {
    key: "show",
    value: function show(text, options) {
      this.showPri(text, options, false);
    }
  }]);

  return QToastClass;
}();

var QToast = new QToastClass();
export { QToast };